// CompareTable (job page): at review, each item sold, billed and used side by side, so a gap shows as
// a red word in its row ("missing · see 1") pointing at the fix above it. A LineTable with the job's
// columns; its foot totals what was sold and billed and says what's short. It draws a CompareView
// (job-view.ts), so a cost is in its foot only when the view has one: the owner's.
import { LineTable, type LineCell } from '../components/LineTable/LineTable.tsx';
import type { CompareView, ViewCell } from './job-view.ts';

export interface CompareTableProps {
  compare: CompareView;
}

const cell = (c: ViewCell): LineCell => c;

export function CompareTable({ compare }: CompareTableProps) {
  return (
    <LineTable
      label="Sold, billed and used"
      columns={[
        { id: 'item', label: 'Item' },
        { id: 'sold', label: 'Sold', sub: compare.soldSub, align: 'end' },
        { id: 'billed', label: 'Billed', sub: compare.billedSub, align: 'end' },
        { id: 'used', label: 'Used', sub: 'from' },
      ]}
      rows={compare.rows.map((r) => ({
        id: r.id,
        cells: { item: r.item, sold: cell(r.sold), billed: cell(r.billed), used: cell(r.used) },
      }))}
      foot={{
        item: 'Total',
        sold: compare.foot.sold,
        billed: compare.foot.billed,
        used: cell(compare.foot.used),
      }}
    />
  );
}
